export interface AssetDetail {
  AssetId?: string;
  AssetName?: string;
  FileName?: string;
  FileType?: string;
  WebUrl?: string;
  ZipConfig?: string;
}
